/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { ListCell, Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabel, useLabels } from '@/wpt-lib/pdf/useData';

const MicroCredentialsDelivery = ({
    lookupSubject,
    lookupSubjectCode,
    teachingSubjectCourseType,
    teachingMicrocredentialType,
    expectNumberOfStudent,
}: Partial<{
    lookupSubject: string;
    lookupSubjectCode: string;
    teachingSubjectCourseType: string;
    teachingMicrocredentialType: Record<string, boolean>;
    expectNumberOfStudent: string;
}>) => {
    const labels = useLabels('teachingMicrocredentialType');

    return (
        <>
            <Row widths={[30, 70]}>
                <ValueCell
                    single
                    label="Type of subject or course"
                    value={useLabel('teachingSubjectCourseType', teachingSubjectCourseType ?? '')}
                />
                <ValueCell single label="Course" value={`${lookupSubjectCode || ''} ${lookupSubject || ''}`} />
            </Row>
            <Row>
                <ListCell
                    single
                    label="Micro-credential Activities"
                    values={Object.entries(teachingMicrocredentialType ?? {})
                        .filter(([, v]) => v)
                        .map(([k]) => labels[k] ?? k)}
                />
            </Row>
            <Row>
                <ValueCell
                    single
                    label="Expected number of students (based on last year’s numbers)"
                    value={expectNumberOfStudent}
                />
            </Row>
        </>
    );
};

export default MicroCredentialsDelivery;
